import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, Plus, Minus, ChevronDown, Upload, Search } from "lucide-react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";
import ShowTimeServices from "../../services/externalServices/TicketServices/showTimeServices";
import clapperboardIcon from '../../../assets/images/film-slate.png';

// The working one

const AddMovies = () => {
  const navigate = useNavigate();
  const [movieData, setMovieData] = useState({
    name: "",
    about: "",
    duration: "",
    genre: [],
    imdbRating: "",
    cast: [],
    crew: [],
    imageUrl: "",
    trailerUrl: "",
    releaseDate: "",
    censorRating: "",
    movieLanguages: [],
    isReadyForBooking: false,
    accessList: [],
    createdBy: "",
  });

  const [openModal, setOpenModal] = useState(false);
  const [showtimeData, setShowtimeData] = useState({
    validityFrom: null,
    validityUntil: null,
    theatreDetails: [],
  });

  const initialMovieData = {
    name: "",
    about: "",
    duration: "",
    genre: [],
    imdbRating: "",
    imageUrl: "",
    trailerUrl: "",
    releaseDate: "",
    censorRating: "",
    movieLanguages: [],
    cast: [],
    crew: [],
  };

  const [theatres, setTheatres] = useState([]);
  const [suggestions] = useState({
    genres: ["Action", "Comedy", "Drama", "Horror", "Romance", "Adventure"],
    castRoles: ["Actor", "Actress", "Director", "Producer"],
  });

  const [submitted, setSubmitted] = useState(false);
  const { firstname, role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));

  // useEffect(() => {
  //   const fetchTheatres = async () => {
  //     try {
  //       const response = await TheatreServices.getTheatres();
  //       setTheatres(response);
  //     } catch (error) {
  //       console.error("Error fetching theaters:", error);
  //     }
  //   };
  //   fetchTheatres();
  // }, []);


  // useEffect(() => {
  //   if (role === "ticket-admin" && theatres.length > 0) {
  //     const adminTheatres = theatres
  //       .filter(theatre => accessList.includes(theatre.name))
  //       .map(theatre => theatre._id);

  //     if (adminTheatres.length > 0) {
  //       setMovieData(prev => ({
  //         ...prev,
  //         accessList: adminTheatres
  //       }));
  //     }
  //   } else if (theatres.length > 0) {
  //     // Set first theatre as default for non-ticket-admin users
  //     setMovieData(prev => ({
  //       ...prev,
  //       accessList: [theatres[0]._id]
  //     }));
  //   }
  // }, [theatres, role, accessList]);


  const [metaLoading, setMetaLoading] = useState(false);
  const [metaError, setMetaError] = useState("");
  const lastRequestedTitleRef = useRef("");
  const lastAppliedTitleRef = useRef("");
  const abortRef = useRef(null);
  const [metaPreview, setMetaPreview] = useState(null); // fetched 
  const [defaultAvailableIn, setDefaultAvailableIn] = useState([]);

  const [searchResults, setSearchResults] = useState([]); // List of movie search matches
  const [selectedMoviePreview, setSelectedMoviePreview] = useState(null); // Single selected movie detail for preview

  // Default languages to use when metadata lacks languages
  const ALL_LANGUAGES = ["English", "Tamil", "Telugu", "Kannada", "Hindi", "Malayalam"];


  // Utility: autofill values from TMDB/IMDB. If overwrite=true, replace existing values.
  const applyTMDbToForm = (tmdb, overwrite = false) => {
    setMovieData(prev => {
      if (overwrite) {
        return {
          ...prev,
          name: tmdb.title || tmdb.name || prev.name || "",
          about: tmdb.overview || "",
          duration: tmdb.runtime ? `${tmdb.runtime} min` : "",
          genre: Array.isArray(tmdb.genres) ? tmdb.genres : [],
          imdbRating: tmdb.voteAverage ? String(tmdb.voteAverage) : "",
          imageUrl: tmdb.posterUrl || "",
          trailerUrl: tmdb.trailerUrl || "",
          releaseDate: tmdb.releaseDate || "",
          cast: tmdb.cast ? tmdb.cast.map(castMember => ({
            name: castMember.name || "",
            inAs: castMember.character || "",
            imageURL: castMember.profileUrl || "",
            priority: 0,
          })) : [],
          crew: tmdb.directors ? tmdb.directors.map(director => ({
            name: director.name || "",
            role: "Director",
            imageURL: director.profileUrl || "",
            priority: 0,
          })) : [],
          movieLanguages: (Array.isArray(tmdb.movieLanguages) && tmdb.movieLanguages.length)
            ? tmdb.movieLanguages
            : ALL_LANGUAGES,
          // accessList and other mandatory fields remain untouched
        };
      }
      // Merge mode (fallback)
      return {
        ...prev,
        about: prev.about || tmdb.overview || "",
        duration: prev.duration || (tmdb.runtime ? `${tmdb.runtime} min` : ""),
        genre: prev.genre.length ? prev.genre : (tmdb.genres || []),
        imdbRating: prev.imdbRating || (tmdb.voteAverage ? tmdb.voteAverage.toString() : ""),
        imageUrl: prev.imageUrl || tmdb.posterUrl || "",
        trailerUrl: prev.trailerUrl || "",
        releaseDate: prev.releaseDate || tmdb.releaseDate || "",
        cast: prev.cast.length ? prev.cast : (tmdb.cast ? tmdb.cast.map(castMember => ({
          name: castMember.name || "",
          inAs: castMember.character || "",
          imageURL: castMember.profileUrl || "",
          priority: 0,
        })) : []),
        crew: prev.crew.length ? prev.crew : (tmdb.directors ? tmdb.directors.map(director => ({
          name: director.name || "",
          role: "Director",
          imageURL: director.profileUrl || "",
          priority: 0,
        })) : []),
        movieLanguages: prev.movieLanguages.length
          ? prev.movieLanguages
          : ((Array.isArray(tmdb.movieLanguages) && tmdb.movieLanguages.length)
              ? tmdb.movieLanguages
              : ALL_LANGUAGES),
      };
    });
  };


  // useEffect(() => {
  //   const title = movieData.name?.trim();
  //   if (!title || title.length < 3) return;

  //   if (title.toLowerCase() === lastRequestedTitleRef.current) return;

  //   const timer = setTimeout(async () => {
  //     if (abortRef.current) abortRef.current.abort();
  //     const controller = new AbortController();
  //     abortRef.current = controller;

  //     try {
  //       setMetaError("");
  //       setMetaLoading(true);
  //       lastRequestedTitleRef.current = title.toLowerCase();

  //       const resp = await MovieServices.getIMDB({ name: title });


  //       const doc = resp?.data;
  //       const tmdb = doc?.tmdbData;

  //       console.log('tmdb data====', tmdb);

  //       if (!tmdb) {
  //         setMetaError(resp?.data?.message || "Movie not found. Try a different title.");
  //         return;
  //       }

  //       if (tmdb) {
  //         setMetaPreview(tmdb);  // show preview instead of direct autofill
  //       }



  //       // if (tmdb) {
  //       //   setMetaPreview(tmdb);  // show preview instead of direct autofill
  //       // }
  //       if (title.toLowerCase() !== lastAppliedTitleRef.current) {
  //         setMetaPreview(tmdb);
  //         // applyTMDbToForm(tmdb); // merge autofill
  //         // lastAppliedTitleRef.current = title.toLowerCase();
  //       }
  //     } catch (e) {
  //       if (e.name !== "AbortError") {
  //         setMetaError(e.message || "Failed to fetch details");
  //       }
  //     } finally {
  //       setMetaLoading(false);
  //     }
  //   }, 600); // debounce

  //   return () => clearTimeout(timer);
  // }, [movieData.name]);












  // IMDB auto-search on typing disabled; search now only occurs when IMDB button is clicked.








  const handleSelectMovie = async (movie) => {
    try {
      setMetaLoading(true);
      const resp = await MovieServices.fetchAndStoreByImdbId(movie.tmdbId);
      if (resp?.success && resp?.data?.tmdbData) {
        const tmdbData = resp.data.tmdbData;
        try {
          await MovieServices.saveMovie({ name: tmdbData.title || tmdbData.name || movie.title, tmdbData });
        } catch (_) {
          // best-effort save; ignore if already saved
        }
        applyTMDbToForm(tmdbData, true);
        setSearchResults([]);
        setSelectedMoviePreview(null);
        setMetaPreview(null);
      } else {
        alert("Looks like no data updated in IMDB. Please enter manually.");
      }
    } catch (e) {
      alert("Looks like no data updated in IMDB. Please enter manually.");
    } finally {
      setMetaLoading(false);
    }
  };



  // const handleAutofillClick = () => {
  //   applyTMDbToForm(metaPreview);
  //   setMetaPreview(null);  // hide preview after autofill
  // };





  const handleAutofillClick = async () => {};

  const handleImdbClick = async () => {
    const title = movieData.name?.trim();
    if (!title) return;
    try {
      setMetaLoading(true);
      setMetaError("");
      const data = await MovieServices.searchMovie({ name: title });
      if (data?.items?.length) {
        const sorted = [...data.items].sort((a, b) => (parseInt(b.year) || 0) - (parseInt(a.year) || 0));
        setSearchResults(sorted);
      } else if (data?.tmdbData) {
        const d = data.tmdbData;
        const single = {
          tmdbId: d.tmdbId || d.id,
          title: d.title || d.name || title,
          year: (d.releaseDate || d.firstAirDate || '').slice(0, 4),
          posterUrl: d.posterUrl || d.posterPath || '',
        };
        setSearchResults(single.tmdbId ? [single] : []);
        if (!single.tmdbId) setMetaError("Looks like no data updated in IMDB. Please enter manually.");
      } else {
        setSearchResults([]);
        setMetaError("Looks like no data updated in IMDB. Please enter manually.");
      }
    } catch (e) {
      setMetaError("Looks like no data updated in IMDB. Please enter manually.");
    } finally {
      setMetaLoading(false);
    }
  };








  useEffect(() => {
    const fetchTheatres = async () => {
      try {
        const response = await TheatreServices.getTheatres();
        setTheatres(response);

        // Set default accessList after theatres are loaded
        // if (role === "ticket-admin") {
        //   const adminTheatres = response
        //     .filter(theatre => accessList.includes(theatre.name))
        //     .map(theatre => theatre._id);

        //   if (adminTheatres.length > 0) {
        //     setMovieData(prev => ({
        //       ...prev,
        //       accessList: adminTheatres
        //     }));
        //   }
        // } else if (response.length > 0) {
        //   // Set first theatre as default for non-ticket-admin users
        //   setMovieData(prev => ({
        //     ...prev,
        //     accessList: [response[0]._id]
        //   }));
        // }


        if (response.length > 0) {

          // setMovieData(prev => ({
          //   ...prev,
          //   accessList: response.map(theatre => theatre._id)
          // }));


          const theatreIds = response.map(theatre => theatre._id);
          setDefaultAvailableIn(theatreIds);
          setMovieData(prev => ({
            ...prev,
            accessList: theatreIds,
          }));
        }

      } catch (error) {
        console.error("Error fetching theaters:", error);
      }
    };

    fetchTheatres();
  }, []); // Empty dependency array means this runs only once on mount



  // useEffect(() => {
  //   if (role === "ticket-admin" && theatres.length > 0) {
  //     const adminTheatres = theatres
  //       .filter(theatre => accessList.includes(theatre.name))
  //       .map(theatre => theatre._id);

  //     if (adminTheatres.length > 0) {
  //       setMovieData(prev => ({
  //         ...prev,
  //         accessList: adminTheatres
  //       }));
  //     }
  //   }
  // }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMovieData({
      ...movieData,
      [name]: value,
    });
  };

  // Was not able to select the multiple checkbox 
  // const handleArrayChange = (e) => {
  //   const { name, value } = e.target;
  //   setMovieData({
  //     ...movieData,
  //     [name]: value.split(",").map((item) => item.trim()),
  //   });
  // };


  // Happens here
  const handleArrayChange = (e) => {
    const { name, value, checked } = e.target;

    setMovieData((prevState) => {
      const currentArray = prevState[name] || [];

      if (checked) {
        // Add the language if not already present
        return {
          ...prevState,
          [name]: [...currentArray, value],
        };
      } else {
        // Remove the language
        return {
          ...prevState,
          [name]: currentArray.filter((item) => item !== value),
        };
      }
    });
  };


  const handleCastChange = (index, e) => {
    const { name, value } = e.target;
    const newCast = [...movieData.cast];
    newCast[index][name] = value;
    setMovieData({
      ...movieData,
      cast: newCast,
    });
  };

  const handleAddCast = () => {
    setMovieData({
      ...movieData,
      cast: [
        ...movieData.cast,
        { name: "", inAs: "", imageURL: "", priority: 0 },
      ],
    });
  };

  const handleRemoveCast = (index) => {
    const newCast = movieData.cast.filter((_, i) => i !== index);
    setMovieData({
      ...movieData,
      cast: newCast,
    });
  };

  const handleCrewChange = (index, e) => {
    const { name, value } = e.target;
    const newCrew = [...movieData.crew];
    newCrew[index][name] = value;
    setMovieData({
      ...movieData,
      crew: newCrew,
    });
  };

  const handleAddCrew = () => {
    setMovieData({
      ...movieData,
      crew: [
        ...movieData.crew,
        { name: "", role: "", imageURL: "", priority: 0 },
      ],
    });
  };

  const handleRemoveCrew = (index) => {
    const newCrew = movieData.crew.filter((_, i) => i !== index);
    setMovieData({
      ...movieData,
      crew: newCrew,
    });
  };



  const handleGenreChange = (e) => {
    const { value, checked } = e.target;

    setMovieData((prevData) => {
      let updatedGenres = [...prevData.genre];
      if (checked) {
        updatedGenres.push(value);
      } else {
        updatedGenres = updatedGenres.filter((genre) => genre !== value);
      }

      return { ...prevData, genre: updatedGenres };
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    try {
      movieData.createdBy = firstname;
      const response = await MovieServices.addMovie(movieData);

      console.log('respons while creating movie', response.message);

      if (response && response._id) {
        console.log("Movie added successfully:", response);
        setShowtimeData({ ...showtimeData, movieId: response._id });
        alert("Movie successfully added!");
        setMovieData(initialMovieData);
        setSubmitted(true);
        navigate(-1);
      } else if (response.message) {
        alert("❌ " + response.message);
      }
    } catch (error) {
      console.error("Error adding movie:", error);
      const errorMsg = error?.response?.message || "Something went wrong. Movie not added.";
      alert(errorMsg);
    } finally {
      setSubmitted(false);
    }
  };

  const handleShowtimeInputChange = (e) => {
    const { name, value } = e.target;
    setShowtimeData({
      ...showtimeData,
      [name]: value,
    });
  };

  const handleAddShowtime = async () => {
    try {
      await ShowTimeServices.addShowtime(showtimeData);
      console.log("Showtime added:", showtimeData);
      setOpenModal(false);
    } catch (error) {
      console.error("Error adding showtime:", error);
    }
  };

  const handleTheatreChange = (event) => {
    const selectedTheatres = event.target.value.map(id => ({
      theatreId: theatres.find(t => t._id === id),
      showTimes: [],
    }));
    setShowtimeData({
      ...showtimeData,
      theatreDetails: selectedTheatres,
    });
  };

  const handleShowTimesChange = (index, e) => {
    const { value } = e.target;
    const updatedTheatreDetails = [...showtimeData.theatreDetails];
    updatedTheatreDetails[index].showTimes = value.split(",").map(time => time.trim());
    setShowtimeData({
      ...showtimeData,
      theatreDetails: updatedTheatreDetails,
    });
  };


  const handleClear = () => {
    setMovieData(prev => {
      const preservedAccess = Array.isArray(prev.accessList) ? prev.accessList : [];
      const fallback = Array.isArray(defaultAvailableIn) ? defaultAvailableIn : [];
      return {
        ...initialMovieData,
        accessList: preservedAccess.length ? preservedAccess : fallback,
        isReadyForBooking: prev.isReadyForBooking ?? false,
        createdBy: prev.createdBy || "",
      };
    });

    // Reset transient UI state
    lastRequestedTitleRef.current = "";
    lastAppliedTitleRef.current = "";
    setMetaPreview(null);
    setSelectedMoviePreview(null);
    setSearchResults([]);
    setMetaError("");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-purple-50 py-8 px-4">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
        <form onSubmit={handleSubmit} className="space-y-8 p-8">
          {/* Header Section */}
          <div className="flex items-center space-x-4 mb-6">
            <div className="p-2 bg-black rounded-lg shadow-sm mb-2">
              <img
                src={clapperboardIcon}
                alt="clapperboard"
                className="w-6 h-6 text-black"
              />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-gray-800">Register New Movie</h1>
              <p className="text-gray-500 text-sm mt-0.5">Fill in the details below to add a new movie</p>
            </div>
          </div>










          




          {selectedMoviePreview && (
            <div className="preview-panel mt-4 p-4 border rounded bg-gray-50 shadow-md">
              <h2 className="text-2xl font-bold mb-2">{selectedMoviePreview.title}</h2>
              <img src={selectedMoviePreview.posterUrl} alt={selectedMoviePreview.title} className="w-48 rounded" />
              <p className="my-2">{selectedMoviePreview.overview}</p>
              {/* Render cast, crew, languages etc here as needed */}
              <button
                className="mt-3 px-5 py-2 bg-green-600 text-white rounded"
                onClick={() => {
                  applyTMDbToForm(selectedMoviePreview, true);
                  setSelectedMoviePreview(null);
                  setSearchResults([]);  // Optionally clear results after autofill
                }}
              >
                Autofill Form
              </button>
              <button
                className="ml-3 mt-3 px-5 py-2 bg-gray-400 rounded"
                onClick={() => setSelectedMoviePreview(null)}
              >
                Cancel
              </button>
            </div>
          )}



          {/* remove bulky preview to keep UI compact */}

          {/* Form Sections */}
          <div className="space-y-8">
            {/* Basic Information Section */}
            <div className="bg-gray-50 p-6 rounded-xl">
              <h2 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-black pl-3">
                Basic Information
              </h2>
              <div className="space-y-6">
                <div className="space-y-2 md:col-span-2">
                  <label className="text-sm font-medium text-gray-700">Movie Title</label>
                  <div className="relative">
                    <input
                      placeholder="Spider Man"
                      type="text"
                      name="name"
                      value={movieData.name}
                      onChange={handleInputChange}
                      className="w-full pr-28 px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                      required
                    />
                    <button
                      type="button"
                      onClick={handleImdbClick}
                      // title="Fill from IMDB"
                      title="Fill from CruzeDB"
                      className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-yellow-400 text-black text-xs font-semibold shadow hover:bg-yellow-300"
                    >
                      {/* <Search className="w-4 h-4" /> IMDB */}
                      <Search className="w-4 h-4" /> CruzeDB
                    </button>
                  </div>
                  {/* {metaLoading && <div className="text-xs text-gray-500 mt-1">Searching IMDB…</div>} */}
                  {metaLoading && <div className="text-xs text-gray-500 mt-1">Searching CruzeDB…</div>}
                  {metaError && <div className="text-xs text-red-500 mt-1">{metaError}</div>}
                  {searchResults.length > 0 && (
                    <div className="mt-3 -mx-1 overflow-x-auto">
                      <div className="flex gap-3 px-1 w-max">
                        {searchResults.map((movie) => (
                          <div
                            key={movie.tmdbId}
                            onClick={() => handleSelectMovie(movie)}
                            className="min-w-[120px] max-w-[120px] cursor-pointer rounded-lg border border-gray-200 bg-white shadow-sm hover:shadow-md transition p-2"
                          >
                            <img
                              src={movie.posterUrl || ""}
                              alt={movie.title}
                              className="w-full h-40 object-cover rounded"
                            />
                            <div className="mt-1">
                              <div className="text-xs font-semibold truncate" title={movie.title}>
                                {movie.title}
                              </div>
                              <div className="text-[10px] text-gray-500">{movie.year || "N/A"}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="text-[11px] text-gray-500 mt-2 px-1">Tap a result to autofill details</div>
                    </div>
                  )}
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">About</label>
                  <textarea
                    placeholder="Peter Parker's secret identity is revealed to the entire world. Desperate for help, Peter turns to Doctor Strange to make the world forget that he is Spider-Man ..."
                    type="text"
                    name="about"
                    value={movieData.about}
                    onChange={handleInputChange}
                    rows={4}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Duration</label>
                  <input
                    placeholder="2.5 hours"
                    type="text"
                    name="duration"
                    value={movieData.duration}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Censor Rating</label>
                  <input
                    placeholder="UV or UA"
                    type="text"
                    name="censorRating"
                    value={movieData.censorRating}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                    required
                  />
                </div>

                {/* <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Languages</label>
                  <input
                    placeholder="English, Tamil, Telugu, Kannada, Hindi"
                    type="text"
                    name="movieLanguages"
                    value={movieData.movieLanguages.join(", ")}
                    onChange={handleArrayChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                    required
                  />
                </div> */}

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Languages</label>
                  <div className="flex gap-3 flex-wrap md:flex-nowrap">
                    {["English", "Tamil", "Telugu", "Kannada", "Hindi", "Malayalam"].map((language, index) => (
                      <label key={index} htmlFor={language} className="shrink-0 inline-flex items-center gap-2 px-3 py-2 rounded border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          id={language}
                          name="movieLanguages"
                          value={language}
                          checked={movieData.movieLanguages.includes(language)}
                          onChange={handleArrayChange}
                          className="rounded"
                        />
                        <span className="text-sm text-gray-700">{language}</span>
                      </label>
                    ))}
                  </div>
                </div>






                {/* <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Genres</label>
                  <div className="relative">
                    <select
                      multiple
                      name="genre"
                      value={movieData.genre}
                      onChange={(e) => setMovieData({
                        ...movieData,
                        genre: Array.from(
                          e.target.selectedOptions,
                          (option) => option.value
                        )
                      })}
                      className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 appearance-none scrollbar-thin scrollbar-thumb-purple-300 scrollbar-track-gray-100"
                      required
                    >
                      {suggestions.genres.map((genre) => (
                        <option key={genre} value={genre} className="p-2 hover:bg-gray-50">
                          {genre}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                      <ChevronDown className="w-5 h-5 text-gray-400" />
                    </div>
                  </div>
                </div> */}


                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Genres</label>
                  <div className="flex gap-3 flex-wrap md:flex-nowrap">
                    {suggestions.genres.map((genre) => (
                      <label key={genre} htmlFor={genre} className="shrink-0 inline-flex items-center gap-2 px-3 py-2 rounded border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          id={genre}
                          name="genre"
                          value={genre}
                          checked={movieData.genre.includes(genre)}
                          onChange={handleGenreChange}
                          className="rounded"
                        />
                        <span className="text-sm text-gray-700">{genre}</span>
                      </label>
                    ))}
                  </div>
                </div>


                {/* <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Ready for Booking</label>
                  <select
                    name="isReadyForBooking"
                    value={movieData.isReadyForBooking}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                  >
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                  </select>
                </div> */}

                {/* <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700 block">Ready for Booking</label>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="isReadyForBooking"
                      checked={movieData.isReadyForBooking}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: 'isReadyForBooking',
                            value: e.target.checked,
                          },
                        })
                      }
                      className="rounded text-green-600 focus:ring-green-500"
                    />
                    <span className="text-gray-700">Yes</span>
                  </div>
                </div> */}




                {/* <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Access List (Theatres)</label>
                  <select
                    multiple
                    name="accessList"
                    value={Array.isArray(movieData.accessList) ? movieData.accessList : []}
                    onChange={(e) => {
                      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                      setMovieData({
                        ...movieData,
                        accessList: selectedOptions
                      });
                    }}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                  >
                    {role !== "ticket-admin" ? (
                      theatres.map((theatre) => (
                        <option key={theatre._id} value={theatre._id}>
                          {theatre.name}
                        </option>
                      ))
                    ) : (
                      theatres
                        .filter((theatre) => accessList.includes(theatre.name))
                        .map((theatre, index) => (
                          <option key={theatre._id} value={theatre._id} selected={index === 0} >
                            {theatre.name}
                          </option>
                        ))
                    )}
                  </select>
                </div> */}







                {/* <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Access List (Theatres)</label>
                  <select
                    multiple
                    name="accessList"
                    value={Array.isArray(movieData.accessList) ? movieData.accessList : []}
                    onChange={(e) => {
                      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                      setMovieData({
                        ...movieData,
                        accessList: selectedOptions
                      });
                    }}
                    // className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                  >
                   

                    {role !== "ticket-admin" ? (
                      theatres.map((theatre) => (
                        <option
                          key={theatre._id}
                          value={theatre._id}
                          style={{
                            backgroundColor: movieData.accessList?.includes(theatre._id) ? '#0057d9' : 'transparent',
                            fontWeight: movieData.accessList?.includes(theatre._id) ? '600' : 'normal'
                          }}
                        >
                          {theatre.name}
                        </option>
                      ))
                    ) : (
                      theatres
                        .filter((theatre) => accessList.includes(theatre.name))
                        .map((theatre) => (
                          <option
                            key={theatre._id}
                            value={theatre._id}
                            style={{
                              backgroundColor: movieData.accessList?.includes(theatre._id) ? '#0057d9' : 'transparent',
                              fontWeight: movieData.accessList?.includes(theatre._id) ? '600' : 'normal'
                            }}
                          >
                            {theatre.name}
                          </option>
                        ))
                    )}
                  </select>
                </div> */}


              </div>
            </div>

            {/* Media Details Section */}
            <div className="bg-gray-50 p-6 rounded-xl">
              <h2 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-black pl-3">
                Media Details
              </h2>
              <div className="grid grid-cols-1 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">IMDb Rating</label>
                  <input
                    placeholder="8.2"
                    type="text"
                    name="imdbRating"
                    value={movieData.imdbRating}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Poster Image URL</label>
                  <input
                    type="text"
                    name="imageUrl"
                    value={movieData.imageUrl}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                    required
                  />
                  <label className="relative cursor-pointer inline-block">
                    <input
                      type="file"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files && e.target.files[0];
                        if (file) {
                          const imageUrl = URL.createObjectURL(file);
                          setMovieData({ ...movieData, imageUrl });
                        }
                      }}
                    />
                    <div className="inline-flex items-center gap-2 px-3 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition-colors">
                      <Upload className="w-4 h-4" /> Upload
                    </div>
                  </label>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Trailer URL</label>
                  <input
                    type="text"
                    name="trailerUrl"
                    value={movieData.trailerUrl}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"

                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Release Date</label>
                  <input
                    type="date"
                    name="releaseDate"
                    value={movieData.releaseDate}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Cast Section */}
            <div className="bg-gray-50 p-6 rounded-xl space-y-4">
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-semibold text-gray-800 border-l-4 border-black pl-3">Cast</h2>
                <button
                  type="button"
                  onClick={handleAddCast}
                  className="mb-4 flex items-center px-4 py-2 bg-black hover:bg-gray-800 text-white rounded-md"
                >
                  <Plus className="w-4 h-4 mr-1" />
                  Add Cast
                </button>
              </div>

              {movieData.cast.map((castMember, index) => (
                <div key={index} className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                    <input
                      placeholder="Alex"
                      type="text"
                      name="name"
                      value={castMember.name}
                      onChange={(e) => handleCastChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                    <input
                      placeholder="Hero"
                      type="text"
                      name="inAs"
                      value={castMember.inAs}
                      onChange={(e) => handleCastChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Image URL</label>
                    <input
                      type="text"
                      name="imageURL"
                      value={castMember.imageURL}
                      onChange={(e) => handleCastChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"

                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                    <input
                      type="number"
                      name="priority"
                      value={castMember.priority}
                      onChange={(e) => handleCastChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>
                  <div className="md:col-span-1 flex justify-center">
                    <button
                      type="button"
                      onClick={() => handleRemoveCast(index)}
                      className="p-2 text-red-600 hover:text-red-800"
                    >
                      <Minus className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Crew Section */}
            <div className="bg-gray-50 p-6 rounded-xl space-y-4">
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-semibold text-gray-800 border-l-4 border-black pl-3">Crew</h2>
                <button
                  type="button"
                  onClick={handleAddCrew}
                  className="mb-4 flex items-center px-4 py-2 bg-black hover:bg-gray-800 text-white rounded-md"
                >
                  <Plus className="w-4 h-4 mr-1" />
                  Add Crew
                </button>
              </div>

              {movieData.crew.map((crewMember, index) => (
                <div key={index} className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={crewMember.name}
                      onChange={(e) => handleCrewChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                    <input
                      type="text"
                      name="role"
                      value={crewMember.role}
                      onChange={(e) => handleCrewChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Image URL</label>
                    <input
                      type="text"
                      name="imageURL"
                      value={crewMember.imageURL}
                      onChange={(e) => handleCrewChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"

                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                    <input
                      type="number"
                      name="priority"
                      value={crewMember.priority}
                      onChange={(e) => handleCrewChange(index, e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>
                  <div className="md:col-span-1 flex justify-center">
                    <button
                      type="button"
                      onClick={() => handleRemoveCrew(index)}
                      className="p-2 text-red-600 hover:text-red-800"
                    >
                      <Minus className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Submit Button */}
            <div className="flex justify-center space-x-4">
              <button
                type="submit"
                disabled={submitted}
                className={`flex items-center px-6 py-2 rounded-md ${submitted ? 'bg-gray-400' : 'bg-black hover:bg-gray-800'} text-white font-medium`}
              >
                <CheckCircle className="w-5 h-5 mr-2" />
                {submitted ? 'Submitted' : 'Submit'}
              </button>
              <button
                type="button"
                disabled={submitted}
                className="flex items-center px-6 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-medium"
                onClick={handleClear}
              >
                Clear
              </button>


            </div>
          </div>
        </form>

        {/* Showtime Modal */}
        {openModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
              <div className="px-6 py-4 border-b">
                <h3 className="text-lg font-semibold text-gray-900">Showtime Details</h3>
              </div>
              <div className="p-6 space-y-4">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Validity From</label>
                      <DatePicker
                        value={showtimeData.validityFrom}
                        onChange={(date) => setShowtimeData({ ...showtimeData, validityFrom: date })}
                        renderInput={({ inputRef, inputProps, InputProps }) => (
                          <div className="flex">
                            <input
                              ref={inputRef}
                              {...inputProps}
                              className="w-full px-4 py-2 border border-gray-300 rounded-l-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                            />
                            <div className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50">
                              {InputProps?.endAdornment}
                            </div>
                          </div>
                        )}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Validity Until</label>
                      <DatePicker
                        value={showtimeData.validityUntil}
                        onChange={(date) => setShowtimeData({ ...showtimeData, validityUntil: date })}
                        renderInput={({ inputRef, inputProps, InputProps }) => (
                          <div className="flex">
                            <input
                              ref={inputRef}
                              {...inputProps}
                              className="w-full px-4 py-2 border border-gray-300 rounded-l-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                            />
                            <div className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50">
                              {InputProps?.endAdornment}
                            </div>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </LocalizationProvider>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Select Theatres</label>
                  <select
                    multiple
                    value={showtimeData.theatreDetails.map(t => t.theatreId._id)}
                    onChange={handleTheatreChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    {theatres.map((theatre) => (
                      <option key={theatre._id} value={theatre._id}>{theatre.name}</option>
                    ))}
                  </select>
                </div>

                {showtimeData.theatreDetails.map((theatreDetail, index) => (
                  <div key={index} className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Show Times for {theatreDetail.theatreId.name} (comma separated)</label>
                    <input
                      type="text"
                      value={theatreDetail.showTimes.join(", ")}
                      onChange={(e) => handleShowTimesChange(index, e)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                  </div>
                ))}
              </div>
              <div className="px-6 py-4 border-t flex justify-end space-x-3">
                <button
                  onClick={() => setOpenModal(false)}
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddShowtime}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                >
                  Add Showtime
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddMovies;




















